import "@randajan/jet-core";
import { format, isAfter, isBefore, isSameDay, isToday } from "date-fns";

export const validateEmail = (rawEmail)=>{
    const email = String.jet.to(rawEmail).trim();
    const isValid = !!email && RegExp.jet.lib.email.test(email);
    return { email, isValid, isEmpty:!email };
};


export const isNowBetweenDates = (now, from, to)=>{
    if (!isSameDay(now, from) && isBefore(now, from)) { return false; }
    if (to && isAfter(now, to)) { return false; }
    return true;
}

export const getFilename = (pathname)=>{
    const pathFrags = pathname?.split("/");
    const filenameWithExtension = pathFrags?.pop();
    const filenameFrags = filenameWithExtension?.split(".");
    return filenameFrags?.[0];
}


export const arrToEntries = (arr, byKey, wholeRecord=true)=>{
    if (!Array.isArray(arr)) { return; }
    const index = new Set();

    return arr.map((v, i)=>{
        const key = v[byKey];
        if (index.has(key)) { throw new Error(`Non-unique index ${byKey}`); }
        index.add(key);
        return [key, wholeRecord ? v : i];
    });
}

export const arrToObj = (arr, byKey, wholeRecord=true)=>{
    return Object.fromEntries(arrToEntries(arr, byKey, wholeRecord));
}

export const arrToMap = (arr, byKey, wholeRecord=true)=>{
    return new Map(arrToEntries(arr, byKey, wholeRecord));
}